import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateContactAgreement, privateContactAgreementsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IByPrivateContactAgreementState } from './types';

const PRIVATE_CONTACT_AGREEMENT_MODULE = 'privateContactAgreement';

const state: IByPrivateContactAgreementState = {
    byAgreement: new Map()
};

const dataObjectModule = getDataObjectsModule<IPrivateContactAgreement>(privateContactAgreementsManager, 3);
const searchModule = getSearchModule<IPrivateContactAgreement>(privateContactAgreementsManager);

const privateContactAgreementModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, mutations, getters });
store.registerModule(PRIVATE_CONTACT_AGREEMENT_MODULE, privateContactAgreementModuleInstance);

export { PRIVATE_CONTACT_AGREEMENT_MODULE };
